import classNames from 'classnames';
import React from 'react';

import { Typography } from '@sravni/react-design-system';
import { OptimizedImg } from '@sravni/ugc/lib/optimizedImgV2';

import { getMaterialLink } from '../../helpers/news';
import { THighLight, TPartnerMaterial } from '../../interfaces/news';

import styles from './read-on-block.module.scss';

export interface ICardProps {
  item: THighLight & TPartnerMaterial;
}

export const Card: React.FC<ICardProps> = ({ item }) => {
  const picture = item.miniPicture?.url || item.miniPicture;
  const link = item.externalLink || getMaterialLink(item).as;

  return (
    <Typography.Text size={14} strong>
      <Typography.Link
        color={'dark'}
        href={link}
        target="_blank"
        className={classNames(styles.cardLink, 'h-mb-12')}
        rel="noreferrer"
      >
        {picture?.length ? (
          <OptimizedImg className={styles.cardImg} compression={['s', 's']} src={picture} />
        ) : (
          <div className={styles.plug} />
        )}
        <div dangerouslySetInnerHTML={{ __html: item.title }} className={classNames(styles.cardTitle)} />
      </Typography.Link>
    </Typography.Text>
  );
};
